import React, {CSSProperties, useState} from 'react';
import {Alert, Modal} from 'react-bootstrap';
import {LoadingButton} from '../widgets/LoadingButton/LoadingButton';
import {handleAxiosError} from '../../../util/http';
import {ButtonProps} from 'react-bootstrap/Button';
import {AxiosError} from 'axios';

interface Props {
  open: boolean;
  onAccept: () => Promise<void>;
  onDecline: () => Promise<void>;
  prompt: string | React.ReactNode;
  positiveVariant?: ButtonProps['variant'];
  negativeVariant?: ButtonProps['variant'];
  positiveText?: string;
  negativeText?: string;
  title?: string;
  promptStyles?: CSSProperties;
  titleStyles?: CSSProperties;
}

export function ConfirmationDialog({
     onAccept, onDecline, positiveVariant, negativeVariant, open, prompt,
     positiveText = 'Ok', negativeText = 'Cancel', title, promptStyles, titleStyles
  }: Props) {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | false>(false);
  const confirm = (func: () => Promise<void>) => async () => {
    setLoading(true);
    setErrorMessage(false);
    try {
      await func();
    } catch (e: AxiosError | any) {
        setErrorMessage(handleAxiosError(e));
    }
    setLoading(false);
  };
  return (
    <Modal
      show={open}
      aria-labelledby='contained-modal-title-vcenter'
      centered={true}
    >
      {title ? <Modal.Title style={titleStyles}>{title}</Modal.Title> : null}
      <Modal.Body>
        <Alert show={!!errorMessage} variant='danger'>{errorMessage}</Alert>
        <div style={promptStyles}>{prompt}</div>
      </Modal.Body>
      <Modal.Footer>
        <LoadingButton loading={loading} variant={negativeVariant ?? 'info'} onClick={confirm(onDecline)} label={negativeText}/>
        <LoadingButton loading={loading} variant={positiveVariant ?? 'primary'} onClick={confirm(onAccept)} label={positiveText}/>
      </Modal.Footer>
    </Modal>
  );
}
